import {usePermissions} from "../components/PermissionsContext";
import {permissions} from "../permissions";

export const useUserMandant = () => {
    const userPermissions: string[] = usePermissions();

    const mandantenOfUser: string[] = userPermissions.filter(
        (permission: string): boolean => permission.startsWith('mandant:')
    ).map((permission) => permission.replace('mandant:', ''));

    const isSystemUser: boolean = userPermissions.includes(permissions.system.system);

    const isMandantAnrufer: boolean = userPermissions.includes(permissions.roles.mandantAnrufer);

    const checkMandant: (mandantId: string) => boolean = (mandantId: string): boolean => userPermissions.includes(`mandant:${mandantId}`);

    const checkMandantAndHasOneOfPermissions: (mandantId: string, permissions: string[]) => boolean = (mandantId: string, permissions: string[]): boolean => {
        return checkMandant(mandantId) && permissions.some((permission: string): boolean => userPermissions.includes(permission));
    }

    const checkHasOneOfPermissions: (permissions: string[]) => boolean = (permissions: string[]): boolean => {
        return permissions.some((permission: string): boolean => userPermissions.includes(permission));
    }

    return {
        userPermissions,
        mandantenOfUser,
        isSystemUser,
        isMandantAnrufer,
        checkMandant,
        checkMandantAndHasOneOfPermissions,
        checkHasOneOfPermissions,
    }
}